import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent {
  buttonAction() {
    window.location.href = environment.bealink;
  }
}
